<!--
 * @Date: 2020-08-13 09:35:27
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2020-08-14 11:24:46
 * @FilePath: \pc-mall\src\views\payFailed.vue
-->
<template>
  <div>
    <div class="main_box">
      <!-- <div class="title">预约失败</div> -->
      <!-- 购票进度 -->
      <ProgressPanel :activitiesIndex='activitiesIndex' text='失败'></ProgressPanel>
      <div class="form">
        <img src="../assets/images/error.png" />
        <p class="link">
          <span @click="toPath('/')">{{$t('Backtohome')}}</span>
          <span class="nanputuo-confirm" @click="toPath('/')">重新预约</span>
          <!-- <span v-if="status === '-99' || status === '-1'" class="nanputuo-confirm" @click="PayForTheQuery">支付查询</span> -->
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import CopyRight from '../components/CopyRight'
import {PayForTheQuery} from '@/api/buyTicket'
import ProgressPanel from '../components/ProgressPanel'

export default {
  components: {
    CopyRight,
    ProgressPanel
  },
  data () {
    return {
      orderNo: null,
      status: null,
      baseData: {},
      activitiesIndex: 6
    }
  },
  created () {
    this.orderNo = this.$route.query.orderNo
    this.status = this.$route.query.status
  },
  methods: {
    toPath (path) {
      this.$router.push(path)
    },
    PayForTheQuery () {
      PayForTheQuery(this.orderNo).then(res => {
        if (res.data === 'PAID') {
          this.$confirm('出票成功', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          return false
        }
        if (res.data === 'UNPAID') {
          this.$confirm('订单未支付或者异系统常', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  font-size: 24px;
  line-height: 65px;
  font-weight: bold;
}

.form {
  border: 1px solid #ccc;
  height: 400px;
  padding: 114px 0px 100px 0px;
  margin-bottom: 40px;
  background-color: #fff;
  text-align: center;
}

.link {
  margin-top: 35px;
}

.link span {
  display: inline-block;
  width: 130px;
  height: 44px;
  background: rgba(246, 246, 246, 1);
  border-radius: 6px;
  line-height: 44px;
  margin: 0 20px;
  cursor: pointer;
  &.nanputuo-confirm {
    background: #241008 !important;
    color: #fff !important;
  }
}
.main_box {
  position: relative;
  .schedule {
    position: absolute;
    right: -185px;
    top: 0;
    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 165px;
      height: 40px;
      background: #853D3F;
      color: #FFFFFF;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
    }
    .content {
      padding: 16px 16px;
      background: white;
      padding-right: 0;
      .activity {
        color: #853D3F;
      }
    }
  }
}
</style>
